import {css} from 'twind/css';
export const deleteIconStyles = css({
    '@apply': 'absolute flex justify-center items-center bg-red-500 rounded-full p-1 -right-5 -top-4',
    'svg': {
        '@apply': 'fill-white font-bold',
    }
});
